import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ServicePlanAddendumChild = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ServicePlanAddendumChild' className='file-pdf-document'>
            <div className='file-template'>
            <h3>DIAGNOSIS DSM V (ICD 10) Description or Narrative</h3>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Axis I</span>
            <input type='text' id='txt_1' name='txt_1' className='add-only' />
        </td>
    
    
        <td className='w-375'>
            <span className='eleHeader'>GAF=</span>
            <input type='text' id='txt_2' name='txt_2' className='add-only' />
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Service Plan Addendum</span>
    <input type='checkbox' id='cb_4' name='cb_4' className='add-only' value='1' /> N/A<br/>
    <textarea id='txt_3' name='txt_3' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>New Need Identified:</span>
            <input type='text' id='txt_5' name='txt_5' className='add-only' />
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Goal # </span>
            <input type='text' id='txt_6' name='txt_6' className='add-only'/>
            <input type='text' id='txt_7' name='txt_7' className='add-only'/>
        </td>
    </tr>
    <tr>
    <td className='w-750'>
            <span className='eleHeader'> Target Date:</span>
            <input type='date' id='txt_9' name='txt_9' className='add-only' />
        </td>
        <td>&nbsp;</td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Objectives</span>
    <textarea id='txt_8' name='txt_8' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>New Goal(s)</span>
    <textarea id='txt_11' name='txt_11' className='add-only'></textarea>
</p>
<h3>Termination Criteria</h3>
<h4>(Please have legal Guardian and Client initial each item after reviewing criteria):</h4>
<table>
    <tr>
        <td className='w-375'>
            <input type='checkbox' id='cb_12' name='cb_12' className='add-only' value='1' /> Successful completion of goals and objectives.
        </td>
        <td className='w-375'>
            <input type='checkbox' id='cb_13' name='cb_13' className='add-only' value='1' /> Legal Guardian no longer agrees to services.
        </td>
    </tr>
    <tr>
    <td className='w-375'>
            <input type='checkbox' id='cb_14' name='cb_14' className='add-only' value='1' /> Administrative discharge (Client moves, receives duplicate services from another agency, adjudication, or etc.)
        </td>
        <td className='w-375'>
            <input type='checkbox' id='cb_15' name='cb_15' className='add-only' value='1' /> Non-Compliance: Please
            refer to Attendance Procedures.
        </td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Date of Termination</span>
            <input type='date' id='txt_36' name='txt_36' className='add-only'/>
        </td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Termination Criteria</span>
    <textarea id='txt_15' name='txt_15' className='add-only'></textarea>
</p>
<p className='w-750'>
    <span className='eleHeader'>Methods</span>
    <textarea id='txt_16' name='txt_16' className='add-only'></textarea>
</p>
<table>
    <tr>
        <td className='w-375'>
            <span className='eleHeader'>Service Types</span>
        </td>
        <td className='w-375'>
            <span className='eleHeader'>Frequency</span>
        </td>
    </tr>
    <tr>
    <td className='w-375'>
            <input type='checkbox' id='cb_17' name='cb_17' className='add-only' value='1' /> Assessment/Review
        </td>
        <td className='w-375'>
            <input type='text' id='txt_18' name='txt_18' className='add-only' /> X Annually
        </td>
    </tr>
    <tr>
    <td className='w-375'>
            <input type='checkbox' id='cb_19' name='cb_19' className='add-only' value='1' /> Case Management
        </td>
        <td className='w-375'>
            &nbsp;
        </td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Monitoring</span>
        </td>
    </tr>
    <tr>
        <td className='w-187'>
            <input type='text' id='txt_20' name='txt_20' className='add-only' />
        </td>
        <td className='w-187'>
            <input type='text' id='txt_21' name='txt_21' className='add-only' />
        </td>
        <td className='w-187'>
            <input type='text' id='txt_22' name='txt_22' className='add-only' />
        </td>
        <td className='w-187'>
            <input type='text' id='txt_23' name='txt_23' className='add-only' />
        </td>
    </tr>
    <tr>
        <td className='w-187'>
            <input type='text' id='txt_24' name='txt_24' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_25' name='txt_25' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_26' name='txt_26' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_27' name='txt_27' className='add-only'/>
        </td>
    </tr>
    <tr>
        <td className='w-187'>
            <input type='text' id='txt_28' name='txt_28' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_29' name='txt_29' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_30' name='txt_30' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_31' name='txt_31' className='add-only'/>
        </td>
    </tr>
    <tr>
        <td className='w-187'>
            <input type='text' id='txt_32' name='txt_32' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_33' name='txt_33' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_34' name='txt_34' className='add-only'/>
        </td>
        <td className='w-187'>
            <input type='text' id='txt_35' name='txt_35' className='add-only'/>
        </td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-750'>
            <span className='eleHeader'>Copy of Service Plan</span>
        </td>
    </tr>
    <tr>
        <td className='w-250'>
            <input type='radio' id='rb_36_2' name='rb_36' className='add-only' value='1' /> Hand Delivered
        </td>
        <td className='w-250'>
            <input type='radio' id='rb_36_1' name='rb_36' className='add-only' value='2' /> Mailed
        </td>
        <td className='w-250'>
            <input type='radio' id='rb_36_3' name='rb_36' className='add-only' value='3' /> Both
        </td>
    </tr>
</table>
<p className='w-750'>
    This is to certify that the services prescribed and recommended in this service plan are appropriate and medically
    necessary to meet the recipient’s needs, as defined by the Florida Medicaid Program.
</p>
<table>
    <tr>
        <td className='signature w-250'>&nbsp;</td>
        <td className='signature w-250'>&nbsp;</td>
        <td className='signature w-250'>&nbsp;</td>
    </tr>
    <tr>
        <td className='small w-250'> Program Supervisor </td>
        <td className='small w-250'> Title</td>
        <td className='small w-250'> Date</td>
    </tr>
</table>


                
            </div>
        </form>

    )
}











